export default __webpack_public_path__ + "assets/icon-bank.31054a87.webp";